module.exports = __webpack_public_path__ + "static/media/irregularTriangle4.7927adb3.svg";